/* Product banks are separate editable Shopify sections, each limited to 50 blocks. */
(() => {
  'use strict';
  function collect() {
    const products = [], seen = new Set(), duplicates = [];
    document.querySelectorAll('[data-zi-products]').forEach(node => {
      try {
        const bank = JSON.parse(node.textContent);
        if (!Array.isArray(bank)) return;
        bank.forEach(p => {
          if (!p || !String(p.id || '').trim() || !String(p.en || '').trim()) return;
          p.id = String(p.id).trim();
          if (seen.has(p.id)) { duplicates.push(p.id); return; }
          seen.add(p.id); products.push(p);
        });
      } catch (error) { console.error('Unable to read inquiry product bank', error); }
    });
    let output = document.getElementById('product-data');
    if (!output) { output = document.createElement('script'); output.type = 'application/json'; output.id = 'product-data'; document.body.append(output); }
    output.textContent = JSON.stringify(products);
    window.ZhidaInquiryData = { products, duplicates };
    document.querySelectorAll('[data-zi-data-warning]').forEach(n => n.remove());
    if (duplicates.length && window.Shopify?.designMode) {
      const note = document.createElement('p'); note.dataset.ziDataWarning = ''; note.className = 'zi-storage-warning';
      note.textContent = '商品网址标识重复，请修改：' + [...new Set(duplicates)].join(', ');
      document.body.append(note);
    }
    document.dispatchEvent(new CustomEvent('zi:products:updated'));
  }
  collect();
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', collect);
})();
